// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__J4Tnq","sendOtp":"AuthorizeToLogin_sendOtp__5W9oo"};